import { Subject, Subscription } from 'rxjs';


/**------------------------------------------------------
 * Event Listener State
 */
export class NgEventListener {
	eventName			: string 		 = null!;
	events				: Subject<Event> = null!;
	eventsSubscription	: Subscription 	 = null!;
	teardownCallback	: () => void 	 = null!;
}
